import { HashRouter, Route, Routes } from "react-router-dom";

import { WizardStep } from "shared/hooks/useWizard";

import { WizardInput } from "./components/WizardInput";
import { WizardOptions } from "./components/WizardOptions";
import { WizardRange } from "./components/WizardRange";
import { WizardTextArea } from "./components/WizardTextArea";
import { WizardWrapper } from "./components/WizardWrapper";
import { WizardWelcomeAboutYourself } from "./steps/WelcomeAboutYourself";
import { WizardWelcomeAddPhoto } from "./steps/WelcomeAddPhoto";
import { WelcomeFinish } from "./steps/WelcomeFinish";
import { WelcomeOneMoreThing } from "./steps/WelcomeOneMoreThing";
import { WizardWelcomePreferences } from "./steps/WelcomePreferences";
import { WizardAddPhoto } from "./steps/WizardAddPhoto";
import { WizardLocation } from "./steps/WizardLocation";
import { WizardProfiles } from "./steps/WizardProfiles";
import { WizardData } from "./types";

type Props = { wizardData: WizardData };

const WizardNew = ({ wizardData }: Props) => {
  return (
    <>
      <HashRouter>
        <WizardWrapper wizardData={wizardData}>
          <Routes>
            <Route
              path={WizardStep.WelcomeStep1}
              element={<WizardWelcomePreferences wizardData={wizardData} />}
            />
            <Route
              path={WizardStep.JoinReason}
              element={
                <WizardOptions
                  key={WizardStep.JoinReason}
                  wizardData={wizardData}
                />
              }
            />
            <Route
              path={WizardStep.DateAge}
              element={
                <WizardRange key={WizardStep.DateAge} wizardData={wizardData} />
              }
            />
            <Route
              path={WizardStep.DateBodyType}
              element={
                <WizardOptions
                  key={WizardStep.DateBodyType}
                  wizardData={wizardData}
                />
              }
            />

            <Route
              path={WizardStep.WelcomeStep2}
              element={<WizardWelcomeAboutYourself wizardData={wizardData} />}
            />
            <Route
              path={WizardStep.Location}
              element={
                <WizardLocation
                  wizardData={wizardData}
                  key={WizardStep.Location}
                />
              }
            />
            <Route
              path={WizardStep.BodyType}
              element={
                <WizardOptions
                  key={WizardStep.BodyType}
                  wizardData={wizardData}
                />
              }
            />
            <Route
              path={WizardStep.MaritalStatus}
              element={
                <WizardOptions
                  key={WizardStep.MaritalStatus}
                  wizardData={wizardData}
                />
              }
            />
            <Route
              path={WizardStep.Occupation}
              element={
                <WizardInput
                  key={WizardStep.Occupation}
                  wizardData={wizardData}
                />
              }
            />
            <Route
              path={WizardStep.Interests}
              element={
                <WizardOptions
                  key={WizardStep.Interests}
                  wizardData={wizardData}
                />
              }
            />
            <Route
              path={WizardStep.Bio}
              element={
                <WizardTextArea key={WizardStep.Bio} wizardData={wizardData} />
              }
            />

            <Route
              path={WizardStep.WelcomeStep3}
              element={<WizardWelcomeAddPhoto wizardData={wizardData} />}
            />
            <Route
              path={WizardStep.AddPhoto}
              element={<WizardAddPhoto wizardData={wizardData} />}
            />

            <Route
              path={WizardStep.FinishStep}
              element={<WelcomeFinish wizardData={wizardData} />}
            />

            <Route
              path={WizardStep.OneMoreThing}
              element={<WelcomeOneMoreThing wizardData={wizardData} />}
            />

            <Route
              path={WizardStep.Profiles}
              element={<WizardProfiles wizardData={wizardData} />}
            />
          </Routes>
        </WizardWrapper>
      </HashRouter>
    </>
  );
};

export { WizardNew };
